<form [formGroup]="form" class="kpi-add-form" (ngSubmit)="add()">
    <div class="form-field kpi-add-form__name">
        <label for="kpiAddName" class="form-field__label form-field__label--required">{{
            'results.kpiCarousel.kpiName' | translate
        }}</label>
        <input
            id="kpiAddName"
            type="text"
            pInputText
            formControlName="name"
            [placeholder]="'results.kpiCarousel.kpiNamePlaceholder' | translate" />
        @if (form.controls.name.touched && form.controls.name.hasError('required')) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
        @if (form.controls.name.touched && form.controls.name.hasError('maxlength')) {
            <small class="p-error">{{
                'common.forms.validationMessages.maxLength'
                    | translate: { max: form.controls.name.errors?.['maxlength']?.requiredLength }
            }}</small>
        }
    </div>
    <div class="form-field kpi-add-form__unit">
        <label for="kpiAddUnit" class="form-field__label form-field__label--required">{{
            'results.kpiCarousel.unit' | translate
        }}</label>
        <input
            id="kpiAddUnit"
            type="text"
            pInputText
            formControlName="unit"
            [placeholder]="'results.kpiCarousel.unitPlaceholder' | translate" />
        @if (form.controls.unit.touched && form.controls.unit.hasError('required')) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
        @if (form.controls.unit.touched && form.controls.unit.hasError('maxlength')) {
            <small class="p-error">{{
                'common.forms.validationMessages.maxLength'
                    | translate: { max: form.controls.unit.errors?.['maxlength']?.requiredLength }
            }}</small>
        }
    </div>
    <p-button
        type="submit"
        class="kpi-add-form__submit"
        [label]="'results.kpiCarousel.addKpi' | translate"
        icon="ms ms-add"
        [loading]="saving"></p-button>
</form>
